import { Countries } from "@shared/enums/states.enums";

export interface SelectOption {
    value: string;
    label: string;
}

export const getCountriesAsOptions = (): SelectOption[] => {
    return Object.entries(Countries).map(entry => ({
        value: entry[0],
        label: `${entry[1]} (${entry[0]})`
    }))
}

export const countryFromCode = (countryCode: string): string => {
    return Object.entries(Countries).find((entry) => entry[0] === countryCode)?.[1] || ""
}
